/**
 * Whether the browser tab was loaded by reload / history restore (vs. a fresh link, new tab or typed URL).
 * Unknown type keeps the legacy behaviour (restore).
 */
export function isRestoringNavigation(navigationType: string | undefined): boolean {
  return navigationType === undefined || navigationType === "reload" || navigationType === "back_forward";
}

interface ResolveRestoredActiveTabIdInput {
  savedId: string;
  safePathname: string;
  pathname: string;
  reportIds: string[];
  navigationType: string | undefined;
}

/**
 * Active workspace tab after restoring persisted tabs on first load.
 * The saved active id lives in localStorage shared by all browser tabs, so a saved report
 * is only re-activated on reload; a page opened in a new browser tab keeps its own page tab active.
 */
export function resolveRestoredActiveTabId({
  savedId,
  safePathname,
  pathname,
  reportIds,
  navigationType,
}: ResolveRestoredActiveTabIdInput): string {
  const isPagePreference =
    savedId.startsWith("/panel") &&
    (savedId === safePathname || savedId === pathname);

  if (isPagePreference) {
    return safePathname;
  }

  if (savedId && reportIds.includes(savedId) && isRestoringNavigation(navigationType)) {
    return savedId;
  }

  return safePathname;
}
